import React from 'react';
import { SupplierLayout } from '../../components/SupplierLayout';
import { MOCK_PAYMENTS } from '../../lib/supplierStore';
import { Download, Filter, Search } from 'lucide-react';
export function SupplierPayments() {
  const totalSettled = MOCK_PAYMENTS.filter(p => p.status === 'Settled').reduce((acc, p) => acc + p.amount, 0);
  const totalPending = MOCK_PAYMENTS.filter(p => p.status !== 'Settled').reduce((acc, p) => acc + p.amount, 0);
  return <SupplierLayout data-id="element-3484">
      <div className="max-w-6xl mx-auto" data-id="element-3485">
        <div className="flex items-center justify-between mb-8" data-id="element-3486">
          <h1 className="text-2xl font-display font-bold text-gray-900" data-id="element-3487">
            Payments
          </h1>
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-700 hover:bg-gray-50 transition-colors shadow-sm" data-id="element-3488">
            <Download className="w-4 h-4" data-id="element-3489" /> Export CSV
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-3490">
          <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-3491">
            <p className="text-sm font-bold text-gray-500 mb-2" data-id="element-3492">
              Settled (This Month)
            </p>
            <p className="text-3xl font-display font-bold text-gray-900" data-id="element-3493">
              AED {totalSettled.toLocaleString()}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-3494">
            <p className="text-sm font-bold text-gray-500 mb-2" data-id="element-3495">
              Pending Settlement
            </p>
            <p className="text-3xl font-display font-bold text-brand-600" data-id="element-3496">
              AED {totalPending.toLocaleString()}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-3497">
            <p className="text-sm font-bold text-gray-500 mb-2" data-id="element-3498">
              Lifetime Earnings
            </p>
            <p className="text-3xl font-display font-bold text-gray-900" data-id="element-3499">
              AED 142,500
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-3500">
          <div className="p-4 border-b border-gray-100 flex flex-col sm:flex-row gap-4 justify-between items-center bg-gray-50/50" data-id="element-3501">
            <div className="relative w-full sm:w-64" data-id="element-3502">
              <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-3503" />
              <input type="text" placeholder="Search Job ID or Customer..." className="w-full pl-9 pr-4 py-2 bg-white border border-gray-200 rounded-xl text-sm outline-none focus:border-brand-300" data-id="element-3504" />
            </div>
            <button className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors w-full sm:w-auto justify-center" data-id="element-3505">
              <Filter className="w-4 h-4" data-id="element-3506" /> Filter Status
            </button>
          </div>

          <div className="overflow-x-auto" data-id="element-3507">
            <table className="w-full text-left text-sm" data-id="element-3508">
              <thead className="bg-gray-50 text-gray-500 font-bold uppercase tracking-wider text-[10px]" data-id="element-3509">
                <tr data-id="element-3510">
                  <th className="px-6 py-4" data-id="element-3511">Date</th>
                  <th className="px-6 py-4" data-id="element-3512">Job ID</th>
                  <th className="px-6 py-4" data-id="element-3513">Customer & Service</th>
                  <th className="px-6 py-4" data-id="element-3514">Amount</th>
                  <th className="px-6 py-4" data-id="element-3515">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-3516">
                {MOCK_PAYMENTS.map(p => <tr key={p.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-3517">
                    <td className="px-6 py-4 text-gray-600 whitespace-nowrap" data-id="element-3518">
                      {p.date}
                    </td>
                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap" data-id="element-3519">
                      {p.jobId}
                    </td>
                    <td className="px-6 py-4" data-id="element-3520">
                      <p className="font-bold text-gray-900" data-id="element-3521">{p.customer}</p>
                      <p className="text-xs text-gray-500" data-id="element-3522">{p.service}</p>
                    </td>
                    <td className="px-6 py-4 font-bold text-gray-900 whitespace-nowrap" data-id="element-3523">
                      AED {p.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-3524">
                      <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider ${p.status === 'Settled' ? 'bg-green-100 text-green-700' : p.status === 'Pending' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`} data-id="element-3525">
                        {p.status}
                      </span>
                      {p.settlementDate && <p className="text-[10px] text-gray-400 mt-1" data-id="element-3526">
                          on {p.settlementDate}
                        </p>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </SupplierLayout>;
}